import { CellChip } from './CellChip/CellChip';
import { CellEmoji } from './CellEmoji/CellEmoji';
import CellLink from './CellLink/CellLink';
import { CellText } from './CellText/CellText';
import { CellTimeAgo } from './CellTimeAgo/CellTimeAgo';

export const allCells: Record<FieldType, any> = {
  chip: CellChip,
  emoji: CellEmoji,
  text: CellText,
  timeAgo: CellTimeAgo,
  link: CellLink,
};
